import React, { Component } from 'react';
import { Popover, OverlayTrigger, Table } from "react-bootstrap";
import { BusquedaEstInd, ConsultEmail, CambiarEmail, BuscaInscrito, RetirarEst } from "../../funciones/EstudiantesFunction";
import CustomModal from "../../components/Modal/CustomModal";
import ModalForm from "../../components/Modal/ModalForm";
import DatosInscripcion from "../Inscripcion/DatosInscripcion";
import PerfilCtrl from "../Perfil/PerfilCtrlEst";

import { toast } from 'react-toastify';
import MateriasInscritas from './MateriasInscritas';

class EstudiantesTable extends Component {
    state = {
        boton:{
            icon: "fa fa-mail-forward",
            text: "Inscripción"
        },
        boton2:{
            icon: "fa fa-clone",
            text: "Cambiar de Sección"
        },
        boton3:{
            icon: "fa fa-user-times",
            text: "Retirar"
        },
        botonM:{
            icon: "fa fa-gear",
            text: "Acciones"
        },
        modalBtn1: {
            icon:"fa fa-save",
            text: "Cambiar Email"
        },
        modalBtn2: {
            icon: "fa fa-user-times",
            text: "Retirar",
            disabled: false
        },
        openEmail: false,
        email: "",
        textEmail: "",
        datEst: [],
        openSecc: false,
        openMaterias: false,
        openModalRet: false,
        openModalDatos: false
    }

    constructor (props) {
        super (props)
        
        ConsultEmail (this.props.data.id_estudiante, (resp) => {
            this.setState({
                email: resp
            })
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    modalSecc = () => {
        const { openSecc, datEst } = this.state;
        if (openSecc === false) return null

        let nombre2 = this.props.data.nombre_2;
        let apellido2 = this.props.data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";
        let nombreCompleto = `${this.props.data.nombre_1} ${nombre2} ${this.props.data.apellido_1} ${apellido2}`

        const styles = {
            padding: 5, fontSize: 12
        }

        let materiasInscritas = () => {
            if (datEst.length === 0) return (
                <tr>
                    <td colSpan={3} align="center">Este estudiante no posee materias registradas</td>
                </tr> 
            )

            return (
                datEst.map(option => (
                    <MateriasInscritas key={option.id_seccEst} datos = {option}/>
                ))
            )
        }

        let contenidoModal = () => (
            <React.Fragment>
                <div className="text-danger">Materias Inscritas</div>
                <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", height: "70vh"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="50%" style={styles}><strong>Sección Actual</strong></td>
                                <td align="center" width="50%" style={styles}><strong>Secciones disponibles</strong></td>
                                <td align="center" width="20px" style={styles}></td>
                            </tr>
                            {materiasInscritas()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )

        return (
            <ModalForm
                isopen =  {openSecc}
                titulo = {<div>Cambio de Sección de  {nombreCompleto}</div>}
                contenido = {contenidoModal()}
                cerrar = {() => {this.setState({openSecc: false})}}
            />
        )
    }

    modalEmail = () => {
        const { openEmail, modalBtn1, email, textEmail } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>
                    <div>Email Actual: <a className="text-muted">{email}</a></div>
                    <div>
                        <input type="text" value={textEmail} onChange={this.cambiaValor("textEmail")} placeholder="ejemplo@email.com" className="form-control"/>
                        <div className="text-muted" style={{fontSize: 10}}>Ingresa el nuevo correo. <strong>(Se enviará un email con la contraseña al estudiante)</strong></div>
                    </div>
                </div>
            </React.Fragment>
        )
        
        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openEmail}
                titulo = "Cambiar Email"
                contenido = {contenido()}      
                funcion1 = {() => {
                    this.setState({
                        modalBtn1: {
                            icon:"fa fa-spinner fa-spin",
                            text: "Espera por favor"
                        }
                    }, () => {
                        CambiarEmail(this.props.data.id_estudiante, textEmail, (resp) => {
                            if (resp[1] === "error"){
                                toast.error(resp[0], {autoClose: 4000});
                                this.setState ({
                                    modalBtn1: {
                                        icon:"fa fa-save",
                                        text: "Cambiar Email"
                                    }
                                })
                            }else{
                                toast.info(resp[0], {autoClose: 4000});
                                this.setState ({
                                    modalBtn1: {
                                        icon:"fa fa-save",
                                        text: "Cambiar Email"
                                    },
                                    openEmail: false,
                                    email: textEmail
                                })
                            }
                        })
                    })
                }}
            />
        );
    }

    modalInscripcion = () => {
        let {openMaterias} = this.state;

        let contenido = () => (
            <DatosInscripcion idEst={this.props.data.id_estudiante }
            tlf = {this.props.data.tlf_hab} cel = {this.props.data.tlf_cel}
            email = {this.props.data.email}
            EstCuenta ={false}/>
        )

        let nombre2 = this.props.data.nombre_2;
        let apellido2 = this.props.data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";
        let nombreCompleto = `${this.props.data.nombre_1} ${nombre2} ${this.props.data.apellido_1} ${apellido2}`

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-check"></i> Aceptar</React.Fragment>}
                boton1 = ""
                large = "large"
                isopen =  {openMaterias}
                titulo = {<div className="text-danger" style={{fontSize: 14}}>{`Materias Inscritas de ${nombreCompleto}`}</div>}
                contenido = {contenido()}
                funcion2 = {() => {this.setState({openMaterias: false})}}
            />
        );
    }

    modalRet = () => {
        let { openModalRet, modalBtn2 } = this.state;
        let nombre2 = this.props.data.nombre_2;
        let apellido2 = this.props.data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";
        let nombreCompleto = `${this.props.data.nombre_1} ${nombre2} ${this.props.data.apellido_1} ${apellido2}`

        let retirar = () => {
            if (modalBtn2.disabled === true) return null

            this.setState({
                modalBtn2: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Espera",
                    disabled: true
                }
            }, () => {console.log(this.props.data.id_estudiante);
                RetirarEst (this.props.data.id_estudiante, () => {
                    this.setState({
                        modalBtn2: {
                            icon:"fa fa-sign-out",
                            text: "Retirar",
                            disabled: false
                        },
                        openModalRet: false
                    }, () => {
                        toast.info("Haz retirado al estudiante correctamente.",{autoClose: 4000})
                        this.props.consulta()
                    })
                })
            })
        }

        let contenidoModal = () => (
            <div>
                Esta opción <strong>ELIMINARÁ</strong> a <strong className="text-danger">{nombreCompleto}</strong> de la sección?
                <div><strong>¿Que deseas hacer?</strong></div>
                <div style={{fontSize: 11}} className="custom-mt-10"><strong>Nota:</strong> El histórico del estudiante no quedará eliminado de la base de datos sino solo de la sección. Esta opción no puede deshacerse</div>
            </div>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn2.icon}></i> {modalBtn2.text}</React.Fragment>}
                large = "medium"
                isopen =  {openModalRet}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Confirmación</div>}
                contenido = {contenidoModal()}      
                funcion1 = {retirar}
                funcion2 = {() => {this.setState({openModalRet: false})}}
            />
        )
    }

    modalDatos = () => {
        let { openModalDatos } = this.state;

        if (openModalDatos === false) return null;
        
        let contenido = () => (
            <PerfilCtrl datos = {this.props.data}/>
        )

        let nombre2 = this.props.data.nombre_2;
        let apellido2 = this.props.data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";
        let nombreCompleto = `${this.props.data.nombre_1} ${nombre2} ${this.props.data.apellido_1} ${apellido2}`

        return (
            <CustomModal
                boton2 = ""
                boton1 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                large = "large"
                isopen =  {openModalDatos}
                titulo = {<div className="text-danger" style={{fontSize: 14}}>{`Datos personales de ${nombreCompleto}`}</div>}
                contenido = {contenido()}
                funcion1 = {() => {this.setState({openModalDatos: false})}}
            />
        );
    }

    render() {
        const styles = {
            padding: 5, fontSize: 12
        }
        let { boton, boton2, boton3, botonM } = this.state;
        let nombre2 = this.props.data.nombre_2;
        let apellido2 = this.props.data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";
        let nombreCompleto = `${this.props.data.nombre_1} ${nombre2} ${this.props.data.apellido_1} ${apellido2}`

        let openModal = () => (e) => {
            this.setState({
                botonM:{
                    icon: "fa fa-spinner fa-spin",
                    text: "Cargando"
                },
                openEmail: false,
            }, () => {
                BusquedaEstInd (this.props.data.id_estudiante, (resp) => {
                    this.setState({
                        botonM:{
                            icon: "fa fa-gear",
                            text: "Acciones"
                        } 
                    })
                    this.props.verDatos(resp, nombreCompleto)
                })
            })
            
        }

        let openModalRet = () => (e) => {
            this.setState({
                openModalRet: true
            })
        }

        let openModal2 = () => (e) => {
            this.setState({
                botonM:{
                    icon: "fa fa-spinner fa-spin",
                    text: "Cargando"
                },
                openEmail: false,
            },() => {
                BuscaInscrito(this.props.data.id_estudiante , (resp) => {
                    if (resp.status === "warning"){
                        toast.error(resp.mess, {autoClose: 4000});
                        this.setState({
                            botonM:{
                                icon: "fa fa-gear",
                                text: "Acciones"
                            }
                        })
                    }else{
                        this.setState({
                            botonM:{
                                icon: "fa fa-gear",
                                text: "Acciones"
                            },
                            datEst: resp.EstSecc,
                            openSecc: true
                        })
                    }
                }) 
            })
        }

        let openModal3 = () => {
            this.setState({openMaterias:true})
        }

        let openEmail = () => () =>{
            this.setState({
                openEmail: true
            })
        }

        let contenido = () => {
            return (
                <Popover bsSize="large" id="Ins">
                    <div className="text-primary" onClick = {openModal()} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className={boton.icon}></i> {boton.text}</div>
                    <div className="text-success" onClick = {() => {openModal3()}} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-address-book"></i> Ver Materias Inscritas</div>
                    <div className="text-danger" onClick = {openModal2()} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className={boton2.icon}></i> {boton2.text}</div>
                    <div className="text-warning" onClick = {openEmail()} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-envelope"></i> Cambiar Email</div>
                    <div className="text-info" onClick = {openModalRet()} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className={boton3.icon}></i> {boton3.text}</div>
                    <div className="text-default" onClick = {() => {  this.setState({ openModalDatos: true }) }} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-edit"></i> Editar Datos Personales</div>
                </Popover>
            )
        }

        return (
            <tr>
                <td align="center" style={styles}>{`${this.props.data.nacionalidad} ${this.props.data.ci}`}</td>
                <td style={styles}>{nombreCompleto}</td>
                <td align="center" style={styles} className = "text-danger">{this.props.data.carrera_name}</td>
                <td align="center" style={styles}>
                    <OverlayTrigger ref="overlay" trigger="focus" placement="right" overlay={contenido()}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className={botonM.icon}></i> {botonM.text}</button>
                    </OverlayTrigger>
                </td>
                {this.modalEmail()}
                {this.modalSecc()}
                {this.modalInscripcion()}
                {this.modalRet()}
                {this.modalDatos()}
            </tr>
        );
    }
}
 
export default EstudiantesTable;


// WEBPACK FOOTER //
// ./src/views/Registros/EstudiantesTable.jsx